export default "__VITE_ASSET__04a9f8ea__"